document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.true-slider').forEach(slider => {
    const track = slider.querySelector('.true-slider__track');
    const slides = slider.querySelectorAll('.true-slide');
    const prevBtn = slider.querySelector('.slider-arrow--prev');
    const nextBtn = slider.querySelector('.slider-arrow--next');

    let index = 0;
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    const slideCount = slides.length;

    if (slideCount <= 1) return;

    const updateSlide = () => {
      track.style.transform = `translateX(-${index * 100}%)`;
    };

    const nextSlide = () => {
      index = (index + 1) % slideCount;
      updateSlide();
    };

    const prevSlide = () => {
      index = (index - 1 + slideCount) % slideCount;
      updateSlide();
    };

    // Autoplay
    let autoplay = setInterval(nextSlide, 4000);

    const resetAutoplay = () => {
      clearInterval(autoplay);
      autoplay = setInterval(nextSlide, 4000);
    };

    // Arrows
    nextBtn.addEventListener('click', () => {
      nextSlide();
      resetAutoplay();
    });

    prevBtn.addEventListener('click', () => {
      prevSlide();
      resetAutoplay();
    });

    // Touch swipe
    track.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      isDragging = true;
      clearInterval(autoplay);
    });

    track.addEventListener('touchmove', e => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    });

    track.addEventListener('touchend', () => {
      if (!isDragging) return;
      const diff = startX - currentX;

      if (diff > 50) nextSlide();
      if (diff < -50) prevSlide();

      isDragging = false;
      resetAutoplay();
    });

    // Mouse swipe (desktop)
    track.addEventListener('mousedown', e => {
      startX = e.clientX;
      isDragging = true;
      clearInterval(autoplay);
    });

    track.addEventListener('mouseup', e => {
      if (!isDragging) return;
      const diff = startX - e.clientX;

      if (diff > 50) nextSlide();
      if (diff < -50) prevSlide();

      isDragging = false;
      resetAutoplay();
    });

    track.addEventListener('mouseleave', () => {
      isDragging = false;
    });
  });
});